(function(){
  var idx=0;
  var slides=document.querySelectorAll('.ann-slide');
  if(slides.length>1){
    setInterval(function(){
      slides[idx].style.display='none';
      idx=(idx+1)%slides.length;
      slides[idx].style.display='block';
    },4000);
  }
  document.querySelectorAll('.slider-wrap').forEach(function(w){
    var s=w.querySelector('.slider-track');
    var l=w.querySelector('.sl-prev');
    var r=w.querySelector('.sl-next');
    if(l)l.onclick=function(){s.scrollBy({left:-290,behavior:'smooth'})};
    if(r)r.onclick=function(){s.scrollBy({left:290,behavior:'smooth'})};
  });
})();
